import SecurityAPI from '@/api/security'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    error: null,
    login: null,
    firstName: null,
    lastName: null,
    gender: null,
    mobile: null,
    company: null,
    contactBBA: null,
    isAuthenticated: false,
    isAdmin: false,
    isHotel: false,
    roles: [],
    isImpersonated: false,
    captchaSiteKey: '6Le7He4ZAAAAAFHecec0udRKr_DYfw9VRNJLHYIb',
    maxPricePerRoom: null,
    bookingFees: null,
    orderNumber: null,
    sendVoucherToTravellers: false,
    email2: null,
    offline: false,
    online: false,
    files: null
  },
  getters: {
    isLoading (state) {
      return state.isLoading
    },
    hasError (state) {
      return state.error !== null
    },
    error (state) {
      return state.error
    },
    login (state) {
      return state.login
    },
    mobile (state) {
      return state.mobile
    },
    firstName (state) {
      return state.firstName
    },
    lastName (state) {
      return state.lastName
    },
    gender (state) {
      return state.gender
    },
    user (state) {
      return {
        firstName: state.firstName,
        lastName: state.lastName,
        email: state.login,
        gender: state.gender,
        mobile: state.mobile,
        sendVoucherToTravellers: state.sendVoucherToTravellers,
        offline: state.offline,
        online: state.online
      }
    },
    company (state) {
      return state.company
    },
    contactBBA (state) {
      return state.contactBBA
    },
    isAuthenticated (state) {
      return state.isAuthenticated
    },
    isAdmin (state) {
      return state.isAdmin
    },
    isHotel (state) {
      return state.isHotel
    },
    hasRole (state) {
      return role => {
        return state.roles.indexOf(role) !== -1
      }
    },
    isImpersonated (state) {
      return state.isImpersonated
    },
    maxPricePerRoom (state) {
      return state.maxPricePerRoom
    },
    bookingFees (state) {
      return state.bookingFees
    },
    orderNumber (state) {
      return state.orderNumber
    },
    sendVoucherToTravellers (state) {
      return state.sendVoucherToTravellers
    },
    email2 (state) {
      return state.email2
    },
    files (state) {
      return state.files
    }
  },
  mutations: {
    'AUTHENTICATING' (state) {
      state.isLoading = true
      state.error = null
      state.isAuthenticated = false
      state.isAdmin = false
      state.isHotel = false
      state.roles = []
      state.login = null
      state.company = null
      state.contactBBA = null
      state.firstName = null
      state.lastName = null
      state.gender = null
      state.mobile = null
      state.maxPricePerRoom = null
      state.bookingFees = null
      state.orderNumber = null
      state.sendVoucherToTravellers = false
      state.email2 = null
      state.online = null
      state.offline = null
      state.files = null
      state.isImpersonated = false
    },
    'AUTHENTICATING_SUCCESS' (state, data) {
      state.isLoading = false
      state.error = null
      state.isAuthenticated = true
      state.isAdmin = data.admin
      state.isHotel = data.hotel
      state.roles = data.roles
      state.login = data.login
      state.company = data.company
      state.contactBBA = data.contactBBA
      state.firstName = data.firstName
      state.lastName = data.lastName
      state.gender = data.gender
      state.mobile = data.mobile
      state.maxPricePerRoom = data.maxPricePerRoom
      state.bookingFees = data.bookingFees
      state.orderNumber = data.orderNumber
      state.sendVoucherToTravellers = data.sendVoucherToTravellers
      state.email2 = data.email2
      state.online = data.online
      state.offline = data.offline
      state.files = data.files
    },
    'AUTHENTICATING_ERROR' (state, error) {
      state.isLoading = false
      state.error = error
      state.isAuthenticated = false
      state.isAdmin = false
      state.isHotel = false
      state.roles = []
      state.login = null
      state.company = null
      state.contactBBA = null
      state.firstName = null
      state.lastName = null
      state.gender = null
      state.mobile = null
      state.maxPricePerRoom = null
      state.bookingFees = null
      state.orderNumber = null
      state.sendVoucherToTravellers = false
      state.email2 = null
      state.online = null
      state.offline = null
      state.files = null
    },
    'QUITTING' (state) {
      state.isLoading = false
      state.error = null
      state.isAuthenticated = false
      state.isAdmin = false
      state.isHotel = false
      state.roles = []
      state.login = null
      state.company = null
      state.contactBBA = null
      state.firstName = null
      state.lastName = null
      state.gender = null
      state.mobile = null
      state.maxPricePerRoom = null
      state.bookingFees = null
      state.orderNumber = null
      state.sendVoucherToTravellers = false
      state.email2 = null
      state.online = null
      state.offline = null
      state.files = null
    },
    'IMPERSONATE' (state, bool) {
      state.isImpersonated = bool
    },
    'sendVoucherToTravellers' (state, bool) {
      state.sendVoucherToTravellers = bool
    },
    'changeCompanyLogo' (state, logo) {
      if (state.company) { state.company.logo = logo }
    }
  },
  actions: {
    login ({ commit }, payload) {
      commit('AUTHENTICATING')
      return SecurityAPI.login(payload.login, payload.password)
        .then(res => {
          if (typeof res.data.roles === 'object') {
            res.data.roles = Object.values(res.data.roles)
          }
          commit('AUTHENTICATING_SUCCESS', res.data)
        })
        .catch(err => {
          commit('AUTHENTICATING_ERROR', err)
        })
    },
    loginFormation ({ commit }) {
      commit('AUTHENTICATING')
      return SecurityAPI.login('formation@test.fr', 'formation')
        .then(res => {
          if (typeof res.data.roles === 'object') {
            res.data.roles = Object.values(res.data.roles)
          }
          commit('AUTHENTICATING_SUCCESS', res.data)
        })
        .catch(err => {
          commit('AUTHENTICATING_ERROR', err)
        })
    },
    logout ({ commit }) {
      return SecurityAPI.logout()
        .then(res => commit('QUITTING'))
    },
    impersonate (context, payload) {
      context.commit('AUTHENTICATING_SUCCESS', payload.data)
      context.commit('IMPERSONATE', payload.activate)
    }
  }
}
